export default "__VITE_ASSET__D56EuQyp__"